import { Component, OnInit, Inject, LOCALE_ID } from '@angular/core';
import { Environment } from '@environments/interface.environment';
import { CUSTOMERENVIRONMENT } from '@app/common/app-tokens';

@Component({
  selector: 'app-logo',
  templateUrl: './logo.component.html',
  styleUrls: ['./logo.component.scss']
})
export class LogoComponent implements OnInit {

  logo = this.environment.production ? `/${this.localeId.substr(0, 2)}/assets/logo.svg` : 'assets/logo.svg'; // In production mode we serve the image through webApi so we need to append a trailing slash in order to work.

  constructor(@Inject(CUSTOMERENVIRONMENT) private environment: Environment, @Inject(LOCALE_ID) public localeId: string) {
  }

  ngOnInit() {
  }

}
